import React, { useMemo } from 'react';

const ItemContext = React.createContext({
  itemId: null,
});
export default ItemContext;

export function ItemContextProvider({ children, item }) {
  const value = useMemo(
    () => ({
      item,
    }),
    [item]
  );

  return <ItemContext.Provider value={value}>{children}</ItemContext.Provider>;
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/item_context.jsx